import React from "react"

import TitleVideoSection from "../../../common/sections/title-video/TitleVideoSection"
function RhTitreVideoSection({ title, baseline, imageVideoData }) {
  return (
    <TitleVideoSection
      imageVideoData={imageVideoData}
      title={title}
      baseline={baseline}
    />
  )
}
export const name = "RhTitreVideoSection"

export const init = (componentData) => {

  return (
    <RhTitreVideoSection
      key={componentData.id}
      imageVideoData={componentData.imageVideo}
      title={componentData?.label}
      baseline={componentData?.baseLine}
    />
  )
}

export default RhTitreVideoSection
